import $ from 'jquery';
// jquery-plugin-circliful
// +The MIT License (MIT)
// +
// +Copyright (c) 2014 Patric Gutersohn
// +
// +Permission is hereby granted, free of charge, to any person obtaining a copy of
// +this software and associated documentation files (the "Software"), to deal in
// +the Software without restriction, including without limitation the rights to
// +use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// +the Software, and to permit persons to whom the Software is furnished to do so,
// +subject to the following conditions:
// +
// +The above copyright notice and this permission notice shall be included in all
// +copies or substantial portions of the Software.
// +
// +THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// +IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// +FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// +COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// +IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// +CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


export function circliful(e, o) {
    var t = $.extend({ startdegree: 0, fgcolor: "#556b2f", bgcolor: "#eee", fill: !1, width: 15, dimension: 200, duration: 10, fontsize: 15, percent: 50, animationstep: 1, iconsize: "20px", iconcolor: "#999", border: "default", complete: null, bordersize: 10 },
        e
    );
    return this.each(function () {
        var o,
            l,
            r,
            a,
            d = ["fgcolor", "bgcolor", "fill", "width", "dimension", "fontsize", "animationstep", "duration", "endPercent", "icon", "iconcolor", "iconsize", "border", "startdegree", "bordersize"],
            n = {},
            s = "",
            c = 0,
            f = $(this),
            p = !1;
        if (
            (f.addClass("circliful"),
                (a = f),
                $.each(d, function (e, o) {
                    void 0 != a.data(o) ? (n[o] = a.data(o)) : (n[o] = $(t).attr(o)), "fill" == o && void 0 != a.data("fill") && (p = !0);
                }),
                void 0 != f.data("text") &&
                ((l = ""),
                    void 0 != f.data("icon") &&
                    (s = $("<i></i>")
                        .addClass("osIcon fa " + $(this).data("icon"))
                        .css({ color: n.iconcolor, "font-size": n.iconsize, "line-height": n.iconsize + "px" })),
                    void 0 != f.data("icon-custom") &&
                    (s = $('<img src="' + $(this).data("icon-custom") + '"></img>')
                        .addClass("osIcon ")
                        .css({ width: n.iconsize, height: n.iconsize })),
                    void 0 != f.data("type") && "half" == (T = $(this).data("type")) ? L(f, "circle-text-half", n.dimension / 1.45) : L(f, "circle-text", n.dimension)),
                void 0 != $(this).data("total") && void 0 != $(this).data("part"))
        ) {
            var _ = $(this).data("total") / 100;
            (o = ($(this).data("part") / _ / 100).toFixed(3)), (c = parseFloat(($(this).data("part") / _).toFixed(3)));
        } else void 0 != $(this).data("percent") ? ((o = $(this).data("percent") / 100), (c = $(this).data("percent"))) : (o = t.percent / 100);
        void 0 != $(this).data("info") && ((r = $(this).data("info")), void 0 != $(this).data("type") ? ((T = $(this).data("type")), R(f, "half" == T ? 0.9 : 1.25)) : R(f, 1.25)),
            $(this).width(n.dimension + "px"),
            "line" == T || "vert-line" == T || "half" == T ? $(this).height($(this).data("height") + "px") : $(this).height(n.dimension + "px");
        var h = n.dimension,
            v = n.dimension;
        ("line" == T || "vert-line" == T) && (v = $(this).data("height"));
        ("half" == T) && (v = $(this).data("height"));
        var g = $("<canvas></canvas>").attr({ width: h, height: v }).appendTo($(this)).get(0),
            F = g.getContext("2d");
        //     ,
        //     S = window.devicePixelRatio;
        // if (S) {
        //     var m = $(g);
        //     m.css("width", h), m.css("height", v), m.attr("width", h * S), m.attr("height", v * S), F.scale(S, S);
        // }
        $(g).parent();
        var C = h / 2,
            b = v / 2,
            y = (n.percent, h / 2),
            u = 2.3 * Math.PI,
            x = 0,
            z = 0 === n.animationstep ? c : 0,
            w = Math.max(n.animationstep, 0),
            P = 2 * Math.PI,
            k = Math.PI / 2,
            T = "",
            I = !0,
            G = (n.startdegree / 180) * Math.PI,
            dur = n.duration,
            ts = null;

        function L(e, o, t) {
            $("<span></span>")
                .appendTo(e)
                .addClass(o)
                .html(l)
                .prepend(s)
                .css({ "font-size": n.fontsize + "px", "line-height": n.fontsize + "px" });
        }

        function R(e, o) {
            $("<span></span>").appendTo(e).addClass("circle-info-half").text(r);
        }
        void 0 != $(this).data("type") &&
            ("half" == (T = $(this).data("type")) ? ((u = 2 * Math.PI), (x = Math.PI), (P = Math.PI), (k = Math.PI)) : "angle" == T && ((u = 2.25 * Math.PI), (x = 2.4), (P = 1.53 + Math.PI), (k = 0.73 + Math.PI / 0.996)));
        // $(" > span", this).wrapAll("<div class='centerMe'><div></div></div>");
        var O = 0,
            A = 0,
            B = 2,
            M = 0,
            W = f.data("animation-type");

        function X(e, o, t) {
            for (var l, r, a, d, n, s = e.substring(e.indexOf("(") + 1, e.lastIndexOf(")")).split(/,\s*/), c = o.substring(o.indexOf("(") + 1, o.lastIndexOf(")")).split(/,\s*/), f = 0; f < s.length; f++) s[f] = parseInt(s[f], 10);
            for (var f = 0; f < c.length; f++) c[f] = parseInt(c[f], 10);
            t < 0.5 ?
                ((n = 2 * t), (l = Math.min(255, Math.max(0, s[0] + c[0] * n))), (r = Math.min(255, Math.max(0, s[1] + c[1] * n))), (a = Math.min(255, Math.max(0, s[2] + c[2] * n)))) :
                ((n = (t - 0.5) * 2),
                    (l = Math.min(255, Math.max(0, Math.max(s[0], c[0]) + (c[0] - s[0]) * n))),
                    (r = Math.min(255, Math.max(0, Math.max(s[1], c[1]) + (c[1] - s[1]) * n))),
                    (a = Math.min(255, Math.max(0, Math.max(s[2], c[2]) + (c[2] - s[2]) * n))));
            var d = s[3] + (c[3] - s[3]) * t;
            return "rgba(" + Math.floor(l) + ", " + Math.floor(r) + ", " + Math.floor(a) + ", " + Math.floor(d) + ")";
        }

        function blendROYGBV(current) {
            var r, g, b, a, cur;
            if (current <= .2) {
                r = 255;
                g = 127 * (current * 5);
                b = 0;
            } else if (current <= .4) {
                r = 255;
                g = 128 * ((current - .2) * 5) + 127;
                b = 0;
            } else if (current <= .6) {
                r = 255 * (1 - ((current - .4) * 5));
                g = 255;
                b = 0;
            } else if (current <= .8) {
                r = 0;
                g = 255 * (1 - ((current - .6) * 5));
                b = 255 * ((current - .6) * 5);
            } else {
                r = 127 * ((current - .8) * 5);
                g = 0;
                b = 255;
            }
            return 'rgba(' + Math.floor(r) + ', ' + Math.floor(g) + ', ' + Math.floor(b) + ', ' + 1 + ')';
        }

        function blendVBGYOR(current) {
            var r, g, b, a, cur;
            if (current <= .2) {
                //rgb(127,0,255)
                r = 127 * (1 - ((current) * 5));
                g = 0;
                b = 255;
                //rgb(0,0,255)
            } else if (current <= .4) {
                //rgb(0,0,255)
                r = 0;
                g = 255 * ((current - .2) * 5);
                b = 255 * (1 - ((current - .2) * 5));
                //rgb(0,255,0)
            } else if (current <= .6) {
                //rgb(0,255,0)
                r = 255 * ((current - .4) * 5);
                g = 255;
                b = 0;
                //rgb(255,255,0)
            } else if (current <= .8) {
                //rgb(255,255,0)
                r = 255;
                g = 128 * (1 - ((current - .6) * 5)) + 127;
                b = 0;
                //rgb(255,127,0)
            } else {
                //rgb(255,127,0)
                r = 255;
                g = 127 * (1 - ((current - .8) * 5));
                b = 0;
                //rgb(255,0,0)
            }
            return 'rgba(' + Math.floor(r) + ', ' + Math.floor(g) + ', ' + Math.floor(b) + ', ' + 1 + ')';
        }

        function blendROYGBV(current) {
            var r, g, b, a, cur;
            if (current <= .2) {
                r = 255;
                g = 127 * (current * 5);
                b = 0;
            } else if (current <= .4) {
                r = 255;
                g = 128 * ((current - .2) * 5) + 127;
                b = 0;
            } else if (current <= .6) {
                r = 255 * (1 - ((current - .4) * 5));
                g = 255;
                b = 0;
            } else if (current <= .8) {
                r = 0;
                g = 255 * (1 - ((current - .6) * 5));
                b = 255 * ((current - .6) * 5);
            } else {
                r = 127 * ((current - .8) * 5);
                g = 0;
                b = 255;
            }
            return 'rgba(' + Math.floor(r) + ', ' + Math.floor(g) + ', ' + Math.floor(b) + ', ' + 1 + ')';
        }

        function blendVBGYOR(current) {
            var r, g, b, a, cur;
            if (current <= .2) {
                //rgb(127,0,255)
                r = 127 * (1 - ((current) * 5));
                g = 0;
                b = 255;
                //rgb(0,0,255)
            } else if (current <= .4) {
                //rgb(0,0,255)
                r = 0;
                g = 255 * ((current - .2) * 5);
                b = 255 * (1 - ((current - .2) * 5));
                //rgb(0,255,0)
            } else if (current <= .6) {
                //rgb(0,255,0)
                r = 255 * ((current - .4) * 5);
                g = 255;
                b = 0;
                //rgb(255,255,0)
            } else if (current <= .8) {
                //rgb(255,255,0)
                r = 255;
                g = 128 * (1 - ((current - .6) * 5)) + 127;
                b = 0;
                //rgb(255,127,0)
            } else {
                //rgb(255,127,0)
                r = 255;
                g = 127 * (1 - ((current - .8) * 5));
                b = 0;
                //rgb(255,0,0)
            }
            return 'rgba(' + Math.floor(r) + ', ' + Math.floor(g) + ', ' + Math.floor(b) + ', ' + 1 + ')';
        }

        const waterfallStartX = h / 2 - h / 48;
        const waterfallEndX = h / 2 + h / 48;

        const dropHeight = v / 20;
        const dropWidth = v / 75;
        const dropCount = v / dropHeight * 16;

        let drops = [],
            drops2 = [],
            drops3 = [],
            y1 = 0 - dropHeight,
            y2 = 0 - dropHeight - v * 0.90,
            y3 = 0 - dropHeight - v * 1.8;

        function easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        function setDrops(dropArr) {
            for (let i = 0; i <= dropCount; i++) {
                dropArr[i] = [waterfallStartX + (Math.random() * (waterfallEndX - waterfallStartX)), 0 - dropHeight - (Math.random() * (v + dropHeight)), Math.random() / 4 + 1];
            }
            return dropArr;
        }

        drops = setDrops(drops);
        drops2 = setDrops(drops2);
        drops2 = setDrops(drops3);

        function pour(F, drops, ii, y, ypos) {
            //   F.fillStyle = 'blue';
            F.beginPath();
            let thisY = drops[1] + y * drops[2],
                thisX = drops[0],
                thisHeight = dropHeight,
                thisWidth = dropWidth,
                thisRad = 0;
            if (thisY > ypos) {
                thisHeight = dropWidth;
                thisWidth = dropWidth * 1.5;
                thisRad = dropWidth;
                if (ii % 3 == 0) {
                    thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos, -v / 32, v / 4);
                    if (thisY < ypos - v / 32) {
                        thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos - v / 32, v / 16, v / 4);
                    }
                } else if (ii % 7 == 0) {
                    thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos, -v / 16, v / 4);
                    if (thisY < ypos - v / 16) {
                        thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos - v / 16, v / 10, v / 4);
                    }
                } else {
                    thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos, -v / 64, v / 4);
                    if (thisY < ypos - v / 64) {
                        thisY = easeInOutQuad(drops[1] + y * drops[2] - ypos, ypos - v / 64, v / 32, v / 4);
                    }
                }
                if (ii % 2 == 0) {
                    thisX = drops[0] - ((drops[1] + y * drops[2]) - ypos) / 3;
                    if (ii % 4 == 0) thisX = drops[0] - ((drops[1] + y * drops[2]) - ypos) / 4;
                    else if (ii % 6 == 0) thisX = drops[0] - ((drops[1] + y * drops[2]) - ypos) / 5;
                } else {
                    thisX = drops[0] + ((drops[1] + y * drops[2]) - ypos) / 3;
                    if (ii % 3 == 0) thisX = drops[0] + ((drops[1] + y * drops[2]) - ypos) / 4;
                    else if (ii % 5 == 0) thisX = drops[0] - ((drops[1] + y * drops[2]) - ypos) / 5;
                }
                F.globalAlpha = 0.5 - (drops[2] - 1) * 3;
                F.roundRect(thisX, thisY, thisWidth, thisHeight, thisRad);
            } else {
                F.globalAlpha = 1 - (drops[2] - 1) * 3;
                F.roundRect(thisX, thisY, thisWidth, thisHeight, thisRad);
            }
            if (1 == W) {
                F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t);
                F.fill();
            } else if (e == 4) {
                F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                F.stroke();
            } else if (e == 5) {
                F.strokeStyle = blendVBGYOR(o);
                F.stroke();
            } else if (e == 6) {
                F.strokeStyle = blendROYGBV(o);
                F.stroke();
            } else if (2 == W) {
                var r = F.createLinearGradient(0, 0, 0, v);
                r.addColorStop(0, "white"), r.addColorStop(1, n.fgcolor), D(), (F.fillStyle = r), F.fill(); //, F.clip(),
            } else if (3 == W) {
                //F.clip();
                var r = q(O, h, v);
                (O = Y(O, t)), (F.fillStyle = r), F.fill();
            } else {
                // F.clip(); 
                F.fillStyle = n.fgcolor;
                F.fill();
            }
            // F.fill();
        }
        // ("line" == T || "vert-line" == T) && (n.bordersize = 2 * n.bordersize);
        var Y = function (e, o) {
                return o >= 1 || (e += 0.005), e;
            },
            j = function (e, o) {
                var t = e + o;
                return parseFloat("." + (t = (t = t.toString()).split(".").pop()));
            },
            q = function (e, o, t) {
                var l = F.createLinearGradient(0, 0, o, t);
                return (
                    l.addColorStop(j(0, e), "#FF0000"),
                    l.addColorStop(j(0.1, e), "#FFFF00"),
                    l.addColorStop(j(0.2, e), "#00FF00"),
                    l.addColorStop(j(0.3, e), "#0000FF"),
                    l.addColorStop(j(0.4, e), "#FF00FF"),
                    l.addColorStop(j(0.5, e), "#FF0000"),
                    l.addColorStop(j(0.6, e), "#FFFF00"),
                    l.addColorStop(j(0.7, e), "#00FF00"),
                    l.addColorStop(j(0.8, e), "#0000FF"),
                    l.addColorStop(j(0.9, e), "#FF00FF"),
                    l.addColorStop(j(1, e), "#FF0000"),
                    l
                );
            },
            D = function () {
                (F.shadowColor = n.fgcolor), (F.shadowOffsetX = 0), (F.shadowOffsetY = 0), (F.shadowBlur = 10);
            },
            E = function () {
                (F.lineWidth = n.bordersize + 1), (F.strokeStyle = n.bgcolor), F.stroke(), "fill-circle-faucet" == T || "fill-circle-wave" == T || "grow-circle" == T || "fill-circle" == T || ((F.fillStyle = n.fill), F.fill()), F.beginPath(), F.save();
            },
            H = function (e, o) { //fill animation function
                if (1 == e)(F.strokeStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", o)), F.stroke();
                else if (e == 4) {
                    F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                    F.stroke();
                } else if (e == 5) {
                    F.strokeStyle = blendVBGYOR(o);
                    F.stroke();
                } else if (e == 6) {
                    F.strokeStyle = blendROYGBV(o);
                    F.stroke();
                } else if (2 == e) {
                    if (((F.strokeStyle = n.fgcolor), "line" == T)) {
                        var t = F.createLinearGradient(h, 0, 0, 0);
                        t.addColorStop(0, "white"), t.addColorStop(1, n.fgcolor), (F.strokeStyle = t), D();
                    } else if ("vert-line" == T) {
                        var t = F.createLinearGradient(0, 0, 0, v);
                        t.addColorStop(0, "white"), t.addColorStop(1, n.fgcolor), (F.strokeStyle = t), D();
                    } else {
                        var t = F.createRadialGradient(h / 2, v / 2, h / 2 - 40, v / 2, h / 2, h / 2 - n.bordersize);
                        t.addColorStop(0, n.fgcolor), t.addColorStop(0.5, "white"), t.addColorStop(1, n.fgcolor), (F.strokeStyle = t), D();
                    }
                    F.stroke(), F.restore();
                } else if (3 == e) {
                    if ("line" == T) {
                        var t = q(O, h, v);
                        (O = Y(O, o)), (F.strokeStyle = t);
                    } else if ("vert-line" == T) {
                        var t = F.createLinearGradient(h / 2, 0, h / 2, v);
                        t.addColorStop(j(0, O), "#FF0000"),
                            t.addColorStop(j(0.1, O), "#FFFF00"),
                            t.addColorStop(j(0.2, O), "#00FF00"),
                            t.addColorStop(j(0.3, O), "#0000FF"),
                            t.addColorStop(j(0.4, O), "#FF00FF"),
                            t.addColorStop(j(0.5, O), "#FF0000"),
                            t.addColorStop(j(0.6, O), "#FFFF00"),
                            t.addColorStop(j(0.7, O), "#00FF00"),
                            t.addColorStop(j(0.8, O), "#0000FF"),
                            t.addColorStop(j(0.9, O), "#FF00FF"),
                            t.addColorStop(j(1, O), "#FF0000"),
                            (O = Y(O, o)),
                            (F.strokeStyle = t);
                    } else {
                        var t = q(O, h, v);
                        (O = Y(O, o)), (F.strokeStyle = t);
                    }
                    F.stroke(), F.restore();
                } else(F.strokeStyle = n.fgcolor), F.stroke();
            };
        (function o(t, timestamp) { //animation function
            if (!ts) {
                ts = timestamp;
                z = 0;
            }

            var progress = timestamp - ts;
            if (
                (F.clearRect(0, 0, g.width, g.height),
                    "line" == T || "vert-line" == T ? F.rect(10, 10, h - 20, v - 20) : ("fill-circle-faucet" == T || "fill-circle-wave" == T || "grow-circle" == T || "fill-circle" == T || "full" == T || "half" == T) && (F.beginPath(), F.arc(C, b, y - n.bordersize / 2 - 2, x, u, !1)),
                    (F.fillStyle = n.fill),
                    F.fill(),
                    "line" == T)
            )
                F.beginPath(),
                F.moveTo(20, v - 20 - (n.bordersize / 2)),
                F.lineTo(h - 20, v - 20 - (n.bordersize / 2)),
                E(),
                F.moveTo(20, v - 20 - (n.bordersize / 2)),
                F.lineTo(Math.min((h - 40) * t + 20, h - 20), v - 20 - (n.bordersize / 2)),
                H(W, t);
            else if ("vert-line" == T)
                F.beginPath(),
                F.moveTo(h - 20 - (n.bordersize / 2), v - 20),
                F.lineTo(h - 20 - (n.bordersize / 2), 20),
                E(),
                F.moveTo(h - 20 - (n.bordersize / 2), v - 20),
                F.lineTo(h - 20 - (n.bordersize / 2), Math.max((v - 40) * (1 - t) + 20, 20)),
                H(W, t);
            else if ("full" == T) E(), F.arc(C, b, y - n.bordersize / 2 - 20, -k + G, P * (Math.min(t, 1) + 0.005) - k + G, !1), H(W, t);
            else if ("half" == T && b <= C) E(), F.arc(C, b + (b / 2 * (C / b)) - 20, C - n.bordersize / 2 - 20, -k + G, P * (Math.min(t, 1)) - k + G, !1), H(W, t);
            else if ("half" == T && b > C) E(), F.arc(C, b + (C - 20) / 2 - 10, C - n.bordersize / 2 - 20, -k + G, P * (Math.min(t, 1)) - k + G, !1), H(W, t); //+ (C - 10) / 2
            else if ("grow-circle" == T) {
                E();
                var l = (h / 2) * Math.min(t, 1);
                if ((F.arc(h / 2, v / 2, (y - n.bordersize - 20) * t, x, u, !1), 1 == W))(F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t)), F.fill();
                else if (e == 4) {
                    F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                    F.stroke();
                } else if (e == 5) {
                    F.strokeStyle = blendVBGYOR(o);
                    F.stroke();
                } else if (e == 6) {
                    F.strokeStyle = blendROYGBV(o);
                    F.stroke();
                } else if (2 == W) {
                    var r = F.createLinearGradient(0, 0, 0, v);
                    r.addColorStop(0, "white"), r.addColorStop(1, n.fgcolor), D(), (F.fillStyle = r), F.fill();
                } else if (3 == W) {
                    var r = q(O, h, v);
                    (O = Y(O, t)), (F.fillStyle = r), F.fill();
                } else(F.fillStyle = n.fgcolor), F.fill();
                F.restore();
            } else if ("fill-circle" == T) {
                E();
                var l = h / 2,
                    a = 0.9 * (h * (1 - t)) + 0.05 * h;
                if ((F.arc(h / 2, v / 2, y - n.bordersize - 20, x, u, !1), 1 == W)) F.clip(), (F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t)), F.fillRect(0, a, h, v);
                else if (e == 4) {
                    F.clip();
                    F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                    F.stroke();
                } else if (e == 5) {
                    F.clip();
                    F.strokeStyle = blendVBGYOR(o);
                    F.stroke();
                } else if (e == 6) {
                    F.clip();
                    F.strokeStyle = blendROYGBV(o);
                    F.stroke();
                } else if (2 == W) {
                    var r = F.createLinearGradient(0, 0, 0, v);
                    r.addColorStop(0, "white"), r.addColorStop(1, n.fgcolor), D(), F.clip(), (F.fillStyle = r), F.fillRect(0, a, h, v);
                } else if (3 == W) {
                    F.clip();
                    var r = q(O, h, v);
                    (O = Y(O, t)), (F.fillStyle = r), F.fillRect(0, a, h, v);
                } else F.clip(), (F.fillStyle = n.fgcolor), F.fillRect(0, a, h, v);
                F.restore();
            } else if ("fill-circle-wave" == T) {
                E();
                let a = ((h - n.bordersize - 40) * (1 - t)) + n.bordersize + 20;
                F.arc(h / 2, v / 2, y - n.bordersize - 20, x, u, !1);
                var d = a,
                    s = 0,
                    counterLoop, i;
                (A += 0.1), counterLoop = A;
                var p = (1.5 * Math.PI) / 12;
                for (F.clip(), F.beginPath(), F.moveTo(h, v), F.lineTo(0, v), F.lineTo(0, d), z > c && (B -= 0.0025) < 0 && (B = 0), i = 0; i <= h; i += 10)(s = i), (d -= Math.sin(counterLoop) * B), (counterLoop += p), F.lineTo(s, d);
                if ((F.lineTo(h, v), F.closePath(), 1 == W))(F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t)), F.fill();
                else if (e == 4) {
                    F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                    F.stroke();
                } else if (e == 5) {
                    F.strokeStyle = blendVBGYOR(o);
                    F.stroke();
                } else if (e == 6) {
                    F.strokeStyle = blendROYGBV(o);
                    F.stroke();
                } else if (2 == W) {
                    var r = F.createLinearGradient(0, 0, 0, v);
                    r.addColorStop(0, "white"), r.addColorStop(1, n.fgcolor), D(), F.clip(), (F.fillStyle = r), F.fill();
                } else if (3 == W) {
                    F.clip();
                    var r = q(O, h, v);
                    (O = Y(O, t)), (F.fillStyle = r), F.fill();
                } else F.clip(), (F.fillStyle = n.fgcolor), F.fill();
                F.restore();
            } else if ("fill-circle-faucet" == T) {
                E();
                let l = h / 2,
                    a = ((h - n.bordersize - 40) * (1 - t)) + n.bordersize + 20;
                F.arc(h / 2, v / 2, y - n.bordersize - 20, x, u, !1);
                var d = a,
                    s = 0,
                    counterLoop, counterLoopR, i;
                (A += 0.1), counterLoop = A, counterLoopR = A;
                var p = (1 * Math.PI) / 12;

                F.clip();
                F.beginPath();
                F.moveTo(h, v);
                F.lineTo(0, v);
                F.lineTo(0, d);
                if (z > c) {
                    B -= .0025;
                    if (B < 0) B = 0;
                }
                for (i = 0; i <= h + 12; i += h / 50) {
                    s = i;
                    if (i > h / 2) {
                        d = d - Math.sin(counterLoopR) * B;
                        counterLoopR -= p;
                    } else {
                        d = d - Math.sin(counterLoop) * B;
                        counterLoop += p;
                    }
                    F.lineTo(s, d);
                }
                F.globalAlpha = 1;
                F.lineTo(h, v);
                F.closePath();

                if (1 == W)(F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t)), F.fill();
                else if (e == 4) {
                    F.strokeStyle = X('rgba(0,255,0,1)', 'rgba(255,0,0,1)', o);
                    F.stroke();
                } else if (e == 5) {
                    F.strokeStyle = blendVBGYOR(o);
                    F.stroke();
                } else if (e == 6) {
                    F.strokeStyle = blendROYGBV(o);
                    F.stroke();
                } else if (2 == W) {
                    var r = F.createLinearGradient(0, 0, 0, v);
                    r.addColorStop(0, "white"), r.addColorStop(1, n.fgcolor), D(), (F.fillStyle = r), F.fill();
                } else if (3 == W) {
                    var r = q(O, h, v);
                    (O = Y(O, t)), (F.fillStyle = r), F.fill();
                } else {
                    F.fillStyle = n.fgcolor;
                    F.fill();
                }

                // for (F.clip(), F.beginPath(), F.moveTo(h, v), F.lineTo(0, v), F.lineTo(0, d), z > c && (B -= 0.0025) < 0 && (B = 0), i = 0; i <= h+12; i += h/50)(s = i),
                // i>h/2?
                //     (d -= Math.sin(counterLoopR) * B), (counterLoopR -= p)
                // :
                //     (d -= Math.sin(counterLoop) * B), (counterLoop += p)
                // ,
                // F.lineTo(s, d);

                d = Math.min(v, d + dropHeight / 1.5);

                for (let ii = 0; ii < drops.length; ii++) {

                    pour(F, drops[ii], ii, y1, d);
                    pour(F, drops2[ii], ii, y2, d);
                    pour(F, drops3[ii], ii, y3, d);

                }
                y1 = y1 + v / 50;
                y2 = y2 + v / 50;
                y3 = y3 + v / 50;
                if (y1 >= v * 2.5 && z < 95) {
                    y1 = 0 - dropHeight;
                    drops = setDrops(drops);
                } else if (z >= 95) {
                    //if (!stop) stop = true;
                }
                if (y2 >= v * 2.5 && z < 95) {
                    y2 = 0 - dropHeight;
                    drops2 = setDrops(drops2);
                }
                if (y3 >= v * 2.5 && z < 95) {
                    y3 = 0 - dropHeight;
                    drops3 = setDrops(drops3);
                }

                if (1 == W) {
                    F.fillStyle = X("rgba(255,0,0,1)", "rgba(0,255,0,1)", t);
                    F.fill();
                // } else if (e == 4) {

                // } else if (e == 5) {

                // } else if (e == 6) {

                } else if (2 == W) {
                    F.clip();
                } else if (3 == W) {
                    F.clip();

                } else {
                    F.clip();

                }
                F.restore();

            }
            z < c ?
                ((z = progress / dur * c),
                    requestAnimationFrame(function (timestamp) {
                        (F.strokeStyle = n.fgcolor), o(Math.min(z, c) / 100, timestamp);//}, f
                    })) :
                (M < 1000 && (2 == W || "fill-circle-wave" == T || "fill-circle-faucet" == T)) &&
                ((z = progress / dur * c),
                    (M += 1),
                    requestAnimationFrame(function (timestamp) {
                        (F.strokeStyle = n.fgcolor), o(Math.min(z, c) / 100, timestamp);
                    })),//}, f
                z == c && I && void 0 !== e && $.isFunction(e.complete) && (e.complete(), (I = !1));
        })(z / 100);
    });
}